import WebApi from "@/views/loyalty/shared/modules/web_api"
import { adb_model, mdb_model, monitoring, monitoring_model } from "@/views/monitoring/shared/models/monitoring.model"
import { skud_model } from "@/views/skud/shared/models/skud-log.model"

export class MonitoringPaginationEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_MONITORING_URL}api/pagination/`
        console.log('url', this.url)
        this.webApi = new WebApi()
    }

    async getAdb (adbData) {
        const action = await this.webApi.post(`${this.url}adblog`, adbData)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
            return adb_model
        }
    }

    async getMdb (mdbData) {
        const action = await this.webApi.post(`${this.url}mdblog`, mdbData)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
            return mdb_model
        }
    }

    async getMonitoring (monitoringData) {
        const action = await this.webApi.post(`${this.url}monitoring`, monitoringData)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
            return monitoring_model
        }
    }

    // get offline points
    async getRecordForDashboard (pointData, tableOptions) {
        const action = await this.webApi.post(`${this.url}dashboard`, { pointTimeZones: pointData, page: tableOptions.page, limit: tableOptions.itemsPerPage })
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
        }
    }

    async getSkud (skudData) {
        const action = await this.webApi.post(`${this.url}skudlog`, skudData)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
            return skud_model
        }
    }
}
